import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
   providedIn: 'root'
})
export class HttpPagination {
   hash: string;

   loading = false;
   loadingPercent = 0;

   stop$: Subject<string> = new Subject();
   loadingStop = false;

   stop() {
      this.stop$.next( this.hash );
      this.loadingStop = true;
      this.reset();
   }

   reset() {
      this.hash = null;
      this.loading = false;
      this.loadingPercent = 0;
   }

   hide() {
      if ( this.hash ) { return; }
      this.reset();
   }
}
